var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4639",
    viewBox: "0 0 7.6534624 9.2934895",
    height: "9.2934895mm",
    width: "7.6534624mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4633"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(396.16602,32.706268)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.70555554,0,0,0.70555554,-423.15352,-32.706268)",
    id: "g2331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2333",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 49.097427,4.6488967 H 45.998161 V 0 H 41.349266 V 4.6488967 H 38.25 L 43.673714,10.07261 Z M 38.25,11.622241 v 1.549634 h 10.847427 v -1.549634 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6e9623de2ca39ec6a082a17ffdf65ba0.svg";
export { ForwardRef as ReactComponent };